/* =========================================================================
   Soybarber — capa v2
   Arreglos que no se pueden hacer solo con CSS, porque el tema Vela pinta la
   galeria, los acordeones, el buscador y el widget de Loox con su propio JS.
   Todo tolerante a fallo: si algo no aparece, la pagina sigue funcionando
   con lo que ya pinta el tema.
   ========================================================================= */
(function () {
  'use strict';

  var DESKTOP = 992;
  var eraDesktop = window.innerWidth >= DESKTOP;

  function listo(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  function cada(sel, raiz, fn) {
    Array.prototype.forEach.call((raiz || document).querySelectorAll(sel), fn);
  }
  function lista(coleccion, fn) {
    Array.prototype.forEach.call(coleccion, fn);
  }

  /* --- 1. Estrellas encima de la foto ------------------------------------ */
  function colocarRating() {
    var rate = document.querySelector('.sb-pdp-rate');
    if (!rate) return;
    var destino = window.innerWidth >= DESKTOP
      ? document.querySelector('.product-single__main-media')
      : document.querySelector('.sb-gal');
    if (!destino) return;
    if (rate.parentElement !== destino) destino.appendChild(rate);
    rate.classList.add('is-over');
  }

  /* --- 2. Galeria: foto al frente y contador ----------------------------- */
  function galeria() {
    var pista = document.querySelector('[data-sb-gal-track]');
    if (!pista) return;
    var fotos = pista.children;
    var n = fotos.length;
    if (!n) return;

    fotos[0].classList.add('is-active');

    if (!('IntersectionObserver' in window)) {
      lista(fotos, function (f) { f.classList.add('is-active'); });
    } else {
      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.intersectionRatio > 0.75) e.target.classList.add('is-active');
          else e.target.classList.remove('is-active');
        });
      }, { root: pista, threshold: [0, 0.75, 1] });
      lista(fotos, function (f) { io.observe(f); });
    }

    var salida = document.querySelector('[data-sb-gal-count]');
    if (!salida || n < 2) return;
    var t;
    pista.addEventListener('scroll', function () {
      window.clearTimeout(t);
      t = window.setTimeout(function () {
        var ancho = pista.scrollWidth / n;
        var i = Math.min(n, Math.round(pista.scrollLeft / ancho) + 1);
        salida.textContent = i + '/' + n;
      }, 60);
    }, { passive: true });
  }

  /* --- 3. Descripcion plegada tambien en escritorio ---------------------- */
  function acordeon() {
    var raiz = document.getElementById('product-more-info');
    if (!raiz) return;
    cada('.tab-pane', raiz, function (p) {
      p.className = 'more-info-tabs__multiple-collapse';
    });
    cada('.more-info-tabs__wrapper', raiz, function (w) {
      w.classList.add('collapse');
      w.classList.remove('show');
      w.style.height = '';
    });
    cada('.multiple-collapse__heading', raiz, function (h) {
      h.classList.add('collapsed');
      h.setAttribute('aria-expanded', 'false');
    });
  }

  /* --- 4. Resenas: recorte con degradado y "ver todas" -------------------
     El dato que manda es CUANTAS resenas hay, no cuanto mide el widget: un
     producto con 2 resenas medía 769px y por altura se recortaba igual,
     escondiendo 109px inutiles. */
  var REV_MAX = 660;
  var REV_MIN = 4;
  var REV_MARGEN = 350;

  function numResenas() {
    var el = document.querySelector('[data-sb-rev-count]');
    if (!el) return null;
    var n = parseInt(el.getAttribute('data-sb-rev-count'), 10);
    return isNaN(n) ? null : n;
  }

  function recortarResenas() {
    var w = document.getElementById('looxReviews');
    if (!w || !w.parentNode) return;
    if (w.parentNode.classList && w.parentNode.classList.contains('sb-rev-clamp')) return;

    var pocas = false;
    var n = numResenas();
    if (n !== null && n < REV_MIN) pocas = true;

    var caja = document.createElement('div');
    caja.className = 'sb-rev-clamp';
    w.parentNode.insertBefore(caja, w);
    caja.appendChild(w);

    if (pocas) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sb-rev-more';
    btn.textContent = 'Ver todas las reseñas';
    btn.hidden = true;
    caja.parentNode.insertBefore(btn, caja.nextSibling);

    var abierto = false;
    btn.addEventListener('click', function () {
      abierto = true;
      caja.classList.remove('is-clamped');
      btn.hidden = true;
    });

    function revisar() {
      if (abierto) return;
      var alto = w.getBoundingClientRect().height || w.scrollHeight || 0;
      var sobra = alto > REV_MAX + REV_MARGEN;
      if (sobra) caja.classList.add('is-clamped');
      else caja.classList.remove('is-clamped');
      btn.hidden = !sobra;
    }

    revisar();
    [300, 900, 1800, 3000, 5000, 8000].forEach(function (ms) {
      window.setTimeout(revisar, ms);
    });
    window.addEventListener('load', revisar);
    if ('ResizeObserver' in window) {
      try { new ResizeObserver(revisar).observe(w); } catch (e) {}
    }
  }

  /* --- 5. Fecha estimada de entrega -------------------------------------- */
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  function habiles(desde, n) {
    var d = new Date(desde), s = 0;
    while (s < n) {
      d.setDate(d.getDate() + 1);
      var x = d.getDay();
      if (x !== 0 && x !== 6) s++;
    }
    return d;
  }

  function entrega() {
    var el = document.querySelector('[data-sb-eta]');
    if (!el) return;
    var min = parseInt(el.getAttribute('data-min'), 10) || 3;
    var max = parseInt(el.getAttribute('data-max'), 10) || 5;
    var corte = parseInt(el.getAttribute('data-corte'), 10);
    if (isNaN(corte)) corte = 14;
    var ahora = new Date();
    var hoyCuenta = ahora.getHours() < corte && ahora.getDay() !== 0 && ahora.getDay() !== 6;
    var base = hoyCuenta ? new Date(ahora) : habiles(ahora, 1);
    var d1 = habiles(base, min - 1);
    var d2 = habiles(base, max - 1);
    var mismo = d1.toDateString() === d2.toDateString();
    var cuando = mismo
      ? ('el <b>' + DIAS[d1.getDay()] + ' ' + d1.getDate() + '</b>')
      : ('entre el <b>' + DIAS[d1.getDay()] + ' ' + d1.getDate() + '</b> y el <b>' + DIAS[d2.getDay()] + ' ' + d2.getDate() + '</b>');
    el.innerHTML = (hoyCuenta ? 'Compra hoy y te llega ' : 'Te llega ') + cuando;
  }

  /* --- 6. El boton del buscador decia "Busqueda" ------------------------- */
  function textoBuscar() {
    cada('.search__button', document, function (b) {
      if (/búsqueda/i.test(b.textContent || '')) b.textContent = 'Buscar';
    });
  }

  /* --- 7. Busqueda sin resultados: dar una salida ------------------------
     Searchanise no tolera erratas (babilis, clipers, shaber, maquna dan
     cero), asi que la pantalla de "no hay resultados" se ve seguido. Sin
     nada debajo, el cliente se va. Aqui se le ofrecen las categorias y el
     WhatsApp. Searchanise pinta del lado del cliente y vuelve a pintar al
     filtrar, asi que se revisa varias veces y se comprueba que no este ya
     puesto. */
  function busquedaVacia() {
    var raiz = document.querySelector('.snize-nothing-found');
    if (!raiz || raiz.querySelector('.sb-nores')) return;
    var caja = raiz.querySelector('.snize-no-products-found-text')
            || raiz.querySelector('.snize-no-products-found');
    if (!caja) return;

    var d = document.createElement('div');
    d.className = 'sb-nores';
    d.innerHTML =
      '<p class="sb-nores__t">Revisa como se escribe, o entra por categoria:</p>' +
      '<div class="sb-nores__links">' +
        '<a href="/collections/maquinas-para-cortar-cabello">Maquinas</a>' +
        '<a href="/collections/combos-barberia">Combos</a>' +
        '<a href="/collections/kit-barbero-principiante">Kits de inicio</a>' +
        '<a href="/collections/insumos">Insumos</a>' +
        '<a href="/collections/promo-flash">Promociones</a>' +
      '</div>' +
      '<p class="sb-nores__wa">¿No lo encuentras? ' +
      '<a href="https://wa.me/12183079828">Escríbenos por WhatsApp</a> ' +
      'y te decimos si lo tenemos.</p>';
    caja.appendChild(d);
  }

  function vigilarBusqueda() {
    if (location.pathname.indexOf('search') < 0) return;
    var v = 0;
    var iv = window.setInterval(function () {
      try { busquedaVacia(); } catch (e) {}
      if (++v > 24) window.clearInterval(iv);
    }, 500);
  }

  listo(function () {
    try { colocarRating(); } catch (e) {}
    try { galeria(); } catch (e) {}
    try { acordeon(); } catch (e) {}
    try { recortarResenas(); } catch (e) {}
    try { entrega(); } catch (e) {}
    try { textoBuscar(); } catch (e) {}
    try { vigilarBusqueda(); } catch (e) {}
  });

  var rt;
  window.addEventListener('resize', function () {
    window.clearTimeout(rt);
    rt = window.setTimeout(function () {
      var esDesktop = window.innerWidth >= DESKTOP;
      try { colocarRating(); } catch (e) {}
      if (esDesktop !== eraDesktop) {
        eraDesktop = esDesktop;
        try { acordeon(); } catch (e) {}
      }
    }, 150);
  });
})();
